export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/feature-low-cost.ba74bd59-67aefe.png";